import { data } from '../../svg/AttributeEdit/data';
import { makeIcon } from '../makeIcon';

export const AttributeEdit = makeIcon(data, 'attribute_edit', 'AttributeEdit');

export default AttributeEdit;
